export const nl = {
    start: "Fondsinformatie",
    members: "Members",
    costs: "Costs",
    transactions: "Transactions",
    communication: "Communication",
    customerExperience: "Customer Experience",
    planDesign: "Plan Design",
    submit: "Submit",
    unlock: "Unlock",
    yourResults: "Results",

    naList: ["n.v.t.", "N.V.T.", "nvt", "n.v.t"],
    unknownList: ["Onbekend", "ONBEKEND", "onbekend"],
    numberFormat: { Format: "(0,0)" },
    decimalFormat: { Format: "(0,0.00)" },
    percentFormat: { Format: "(0.0)", Suffix: "%" },
    moneyFormat: { Prefix: "€", Format: "(0,0.00)" },
    thousandFormat: { Format: "(0,0.0)" },// { Prefix: "$", Format: "(0,0 aK)" , Suffix: "K"},
    millionFormat: { Prefix: "€", Format: "(0,0.0)", Suffix: "M" },//{ Prefix: "$", Format: "(0,0 aM)" },
    billionFormat: { Prefix: "€", Format: "(0,0.0)", Suffix: "BN" },//{ Prefix: "$", Format: "(0,0 aB)" },
    decimalSeparator: ",",
    thousandDelimiter: ".",
    //   naList: ["N.V.T.", "n.v.t.", "n.v.t.", "nvt", "n.v.t"],//['na', 'n.a.', 'n/a', 'na.', 'not applicable'],
    na: "n.v.t.", //'<%: Na %>',//'N/A',

    // unknownList: ["Onbekend","onbekend"],//<%= UnknownList %>,//['unknown', 'uk', 'not available', 'not known', 'dont know', "don't know", "don't have", "dont have"],
    unknown: "Onbekend",//'<%: Unknown %>',//"UNKNOWN",
    naNotAllowed: "N.v.t. is niet toegestaan",
    unknownNotAllowed: "Onbekend is niet toegestaan",
    invalidNumber: "Niet toegestaan. Uw antwoord wordt niet opgeslagen.",
    defaultSidebarText: "Click on a field to view last year's value.",
    previousYearValueText: "Previous Year Value",
    addCommentsText: "Toevoegen commentaar",
    dismissText: "Overslaan",
    defaultText: "Gebruikt standaard",
    clickDismiss: "Click to dismiss in dutch",
    addExplanation: "Add Explanation in du",
    singleError: "Er is 1 probleem met uw data, aangegeven in roze hieronder, dat u moet aanpassen voor u de vragenlijst kunt indienen",
    singleWarning: "Er is een ongebruikelijk antwoord geconstateerd, aangegeven in geel hieronder. Kunt u dit antwoord checken en bevestigen. ",
    singleComment: "Er is een ongebruikelijk antwoord geconstateerd. ",
    multipleErrors: "{0} problemen, aangegeven in roze hieronder, die hersteld moeten worden voordat de vragenlijst ingediend kan worden.",
    multipleWarnings: "{0} ongebruikelijke antwoorden, aangegeven in geel hieronder, die u moet checken. Richt de cursor op de aangegeven velden om de foutmelding te kunnen zien",//"{0} unusual data items to be checked.",
    multipleComments: "{0} ongebruikelijke antwoorden met commentaar. ",
    moreErrors: "{0} extra foutmeldingen",
    moreWarnings: "{0} extra waarschuwingen",
    cleanSurveySubmitPage: "Uw vragenlijst is klaar. Klik op verzenden.",
    singleErrorSubmitPage: "1 probleem. Deze is aangegeven in roze.",
    multipleErrorsSubmitPage: "De volgende tabbladen hebben problemen die bekeken en hersteld moeten worden voordat u uw data kunt indienen: {0}. De antwoorden met problemen zijn aangegeven in roze. Richt de cursor op de aangegeven velden om de foutmelding te kunnen zien. Na het herstellen van de problemen (en na het checken van de ongebruikelijke data-elementen aangegeven in geel), kunt u de vragenlijst indien door op  “verzenden” te klikken ",//"{0} problems. They are highlighted in pink.",
    multipleWarningSubmitPage: "The volgende tabbladen bevatten ongebruikelijke data-elementen:{0}. Deze zijn aangegeven in geel. Check alle antwoorden en indien mogelijk, licht toe waarom uw antwoord juist is in de commentaar box. Deze verschijnt zodra u de cursor op het aangegeven dataveld richt. Nadat u alle aangegeven data-elementen heeft gecontroleerd, kunt u de vragenlijst indienen ",
    thisTab: "Dit tabblad heeft ",
    thisSurveyHas: "De vragenlijst heeft ",
    yourComment: "Uw commentaar: ",
    expend: "Expand",
    collapse: "Collapse",
    thisSurveyHasProblems: " De vragenlijst heeft {0} problemen die u eerst moet checken voordat u de vragenlijst kunt indienen: ",
    thisSurveyHasProblem: " De vragenlijst heeft 1 problemen die u eerst moet checken voordat u de vragenlijst kunt indienen: ",
    thisPageHasProblems: " Deze pagina heeft {0} problemen die hersteld moeten worden voordat u de vragenlijst kunt indienen: ",
    thisPageHasProblem: " Deze pagina heeft 1 problemen die hersteld moeten worden voordat u de vragenlijst kunt indienen: ",
    noErrorMsg: "Er is geen foutmelding. ",
    errorMustBeFixed: "Fouten die eerst hersteld dienen te worden voordat de vragenlijst ingediend kan worden",
    contactCEM: "Neem contact op met CEM indien u opnieuw toegang tot uw vragenlijst wilt verkrijgen",
    rolesTable: [{ value: 'PabsStartUser', text: 'Fondsinformatie' }, { value: 'PabsServiceUser', text: 'Service' }, { value: 'PabsCostUser', text: 'Kosten' }, { value: 'PabsTransactionUser', text: 'Transactievolumes' }, { value: 'PabsCustomerExperienceUser', text: 'Customer Experience' }, { value: 'PabsEmployerServiceUser', text: 'Service aan werkgevers' }],  //{ value: 'PabsSatisfactionUser', text: 'Klanttevredenheid' },
    roles: ['BenchmarkNLUser', 'PabsStartUser', 'PabsServiceUser', 'PabsTransactionUser', 'PabsCustomerExperienceUser', 'PabsEmployerServiceUser'],  //'PabsSatisfactionUser', 'PabsCostUser'
    currSurvey: 'Meest recente vragenlijst',
    hisSurvey: 'Historische vragenlijst (read-only)',
    addPreparer: 'Toevoegen datapersonen',
    pressButton: 'Klik "Add" indien u meerdere personen toestemming wilt verlenen om de vragenlijst in te vullen.',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    email: 'E-mail',
    userAccess: 'De gebruiker heeft toegang tot de volgende secties',
    note: 'Opmerking: de nieuwe gebruiker zal een aparte e-mail ontvangen met instructies voor toegang tot de vragen',
    cemSurvey: 'CEM vragenlijsten',
    addEdit: 'Toevoegen/aanpassen datapersoon',
    submitted: 'Verzonden'
}
export default nl;